import * as Highcharts from 'highcharts';

export class HighchartsBuilder {
  private readonly options: Highcharts.Options = {
    title: {
      text: '',
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
  };

  build(): Highcharts.Options {
    return this.options;
  }

  withChart(chartOptions: Highcharts.ChartOptions) {
    this.options.chart = chartOptions;
    return this;
  }

  withSeries(series: Array<Highcharts.SeriesOptionsType>) {
    this.options.series = series;
    return this;
  }

  withXAxis(xAxis: Highcharts.XAxisOptions | Array<Highcharts.XAxisOptions>) {
    this.options.xAxis = xAxis;
    return this;
  }

  withYAxis(yAxis: Highcharts.YAxisOptions | Array<Highcharts.YAxisOptions>) {
    this.options.yAxis = yAxis;
    return this;
  }

  withTitle(title: string) {
    this.options.title.text = title;
    return this;
  }

  withLegend(legend: Highcharts.LegendOptions) {
    this.options.legend = legend;
    return this;
  }

  withTooltip(tooltip: Highcharts.TooltipOptions) {
    this.options.tooltip = tooltip;
    return this;
  }

  withPlotOptions(plotOptions: Highcharts.PlotOptions) {
    this.options.plotOptions = plotOptions;
    return this;
  }
}
